import { render, staticRenderFns } from "./getwayRecord.vue?vue&type=template&id=5095dcee&scoped=true&"
import script from "./getwayRecord.vue?vue&type=script&lang=js&"
export * from "./getwayRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095dcee",
  null
  
)

export default component.exports